import React from "react";

import {
  EXPECTED_FUNDS_TIERS,
  ExpectedFundsTier,
  formatMoney,
} from "./types";

const TIER_BY_KEY = Object.fromEntries(
  EXPECTED_FUNDS_TIERS.map((t) => [t.key, t])
) as Record<ExpectedFundsTier, (typeof EXPECTED_FUNDS_TIERS)[number]>;

/** A small filled square carrying the tier's fill pattern (glyph-independent cue). */
export function TierSwatch({ tier }: { tier: ExpectedFundsTier }) {
  return <span className={`ef-swatch ef-fill-${tier}`} aria-hidden="true" />;
}

/** Confidence pill for the drill-down table — glyph + label, tier-coloured. */
export function TierPill({ tier }: { tier: ExpectedFundsTier }) {
  const t = TIER_BY_KEY[tier];
  if (!t) return <>—</>;
  return (
    <span className={`ef-pill ef-glyph-${tier} para-body-s-medium`}>
      <span aria-hidden="true">{t.glyph}</span> {t.label}
    </span>
  );
}

/** Tier summary card (top-accented, glyph + swatch + amount + caption). */
export function TierCard({
  tier,
  amountCents,
  currency,
  caption,
}: {
  tier: ExpectedFundsTier;
  amountCents: number;
  currency?: string;
  caption?: string;
}) {
  const t = TIER_BY_KEY[tier];
  if (!t) return null;
  return (
    <div className={`ef-tier-card ef-tier-card--${tier}`}>
      <div className="ef-tier-head">
        <TierSwatch tier={tier} />
        <span className={`ef-glyph-${tier}`} aria-hidden="true">
          {t.glyph}
        </span>
        <span className="para-body-s-medium color-text-heading-primary">{t.label}</span>
      </div>
      <p className="heading-h3-semibold color-text-heading-primary mt-05">
        {formatMoney(amountCents, currency)}
      </p>
      {caption ? (
        <p className="para-body-s-regular color-text-body-secondary">{caption}</p>
      ) : null}
    </div>
  );
}
